module.exports = __webpack_public_path__ + "img/sasha.92f833f4.png";